import React, { useState } from 'react';
import { ArrowLeft, Send, MoreVertical } from 'lucide-react';
import { Thread, Message } from '../types';
import { MOCK_MESSAGES } from '../data/mockData';
interface ChatViewProps {
  thread: Thread;
  onBack: () => void;
}
export function ChatView({
  thread,
  onBack
}: ChatViewProps) {
  const [messages, setMessages] = useState<Message[]>(MOCK_MESSAGES);
  const [newMessage, setNewMessage] = useState('');
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    const msg: Message = {
      id: Date.now().toString(),
      senderId: 'me',
      text: newMessage,
      timestamp: 'Just now',
      isMe: true
    };
    setMessages([...messages, msg]);
    setNewMessage('');
  };
  return <div className="flex flex-col h-full bg-white z-50" data-id="element-78">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-100 bg-white/80 backdrop-blur-md sticky top-0 z-10" data-id="element-79">
        <div className="flex items-center gap-3" data-id="element-80">
          <button onClick={onBack} className="p-2 -ml-2 hover:bg-zinc-100 rounded-full transition-colors" data-id="element-81">
            <ArrowLeft size={24} className="text-zinc-600" data-id="element-82" />
          </button>
          <div className="flex items-center gap-3" data-id="element-83">
            <img src={thread.user.photos[0]} alt={thread.user.name} className="w-10 h-10 rounded-full object-cover" data-id="element-84" />
            <div data-id="element-85">
              <h3 className="font-bold text-zinc-900 text-sm" data-id="element-86">
                {thread.user.name}
              </h3>
              <span className="text-xs text-green-500 font-medium" data-id="element-87">Online</span>
            </div>
          </div>
        </div>
        <button className="p-2 hover:bg-zinc-100 rounded-full transition-colors" data-id="element-88">
          <MoreVertical size={20} className="text-zinc-400" data-id="element-89" />
        </button>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-zinc-50" data-id="element-90">
        {messages.map(msg => <div key={msg.id} className={`flex ${msg.isMe ? 'justify-end' : 'justify-start'}`} data-id="element-91">
            <div className={`max-w-[75%] px-4 py-2.5 rounded-2xl text-sm ${msg.isMe ? 'bg-rose-500 text-white rounded-br-none' : 'bg-white text-zinc-900 border border-zinc-100 rounded-bl-none shadow-sm'}`} data-id="element-92">
              {msg.text}
            </div>
          </div>)}
      </div>

      {/* Input */}
      <div className="p-4 bg-white border-t border-zinc-100" data-id="element-93">
        <form onSubmit={handleSend} className="flex items-center gap-2" data-id="element-94">
          <input type="text" value={newMessage} onChange={e => setNewMessage(e.target.value)} placeholder="Type a message..." className="flex-1 bg-zinc-100 text-zinc-900 placeholder-zinc-400 px-4 py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-rose-500/20" data-id="element-95" />
          <button type="submit" disabled={!newMessage.trim()} className="p-3 bg-rose-500 text-white rounded-full disabled:opacity-50 disabled:cursor-not-allowed hover:bg-rose-600 transition-colors" data-id="element-96">
            <Send size={20} data-id="element-97" />
          </button>
        </form>
      </div>
    </div>;
}